import styled from "styled-components";
import ReactTooltip from "react-tooltip";

export const LegendList = styled.ul`
  list-style: none;
  margin: 12px 0 20px;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 20px;
`;

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
  cursor: ${({ $hasInfo }) => ($hasInfo ? "help" : "default")};
`;

export const ColorDot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
  background-color: ${({ $color }) => $color};
`;

export const ReactTooltipStyled = styled(ReactTooltip)`
  max-width: 360px;
  border-radius: 5px !important;
  padding: 12px !important;
  &.show {
    opacity: 1 !important;
  }
`;
